<template>
	<WorkIt>
		<Intro
			title="Website"
			subtitle="Various">
			<p>Before apps and SaaS, there were—and still remain—websites. They endure as the virtual front door for most companies. I have personally and collaboratively brought countless sites to life, and still enjoy the moments when ideas align, clients are impressed, and audiences gain new and better experiences.</p>
		</Intro>

		<div class="mb-6 website-link-m"><a class="text-link" href="https://hce.com/" target="_blank">Hinman Engineers</a></div>
		<div class="container hidden sm:block">
			<div class="flex flex-wrap -mx-3">
				<div class="w-1/2 px-3">
					<img class="m-auto mb-6 box-shadow" src="/img/hinman-1-min.png" srcset="/img/hinman-1@2x-min.png 2x" alt="" />
				</div>
				<div class="w-1/2 px-3">
					<img class="m-auto mb-6 box-shadow" src="/img/hinman-2-min.png" srcset="/img/hinman-2@2x-min.png 2x" alt="" />
				</div>
			</div>
		</div>

		<img class="m-auto sm:hidden box-shadow" src="/img/hinman-m-min.png" srcset="/img/hinman-m@2x-min.png 2x" alt="" />

		<br />
		<br />

		<div class="mb-6 website-link-m"><a class="text-link" href="https://www.westernwater.com/" target="_blank">Western Water</a></div>
		<div class="container hidden sm:block">
			<div class="flex flex-wrap -mx-3">
				<div class="w-1/2 px-3">
					<img class="m-auto mb-6 box-shadow" src="/img/ww-1-min.png" srcset="/img/ww-1@2x-min.png 2x" alt="" />
				</div>
				<div class="w-1/2 px-3">
					<img class="m-auto mb-6 box-shadow" src="/img/ww-2-min.png" srcset="/img/ww-2@2x-min.png 2x" alt="" />
				</div>
			</div>
		</div>

		<img class="m-auto sm:hidden box-shadow" src="/img/western-water-m-min.png" srcset="/img/western-water-m@2x-min.png 2x" alt="" />

		<br />
		<br />

		<div class="hidden sm:block">
			<div class="mb-6">Classics</div>
			<div class="container">
				<div class="flex flex-wrap -mx-3">
					<div class="w-1/2 px-3">
						<img class="m-auto mb-6 box-shadow" src="/img/liquid-min.png" srcset="/img/liquid@2x-min.png 2x" alt="" />
						<img class="m-auto mb-6 box-shadow" src="/img/frebbys-min.png" srcset="/img/frebbys@2x-min.png 2x" alt="" />
					</div>
					<div class="w-1/2 px-3">
						<img class="m-auto mb-6 box-shadow" src="/img/fender-min.png" srcset="/img/fender@2x-min.png 2x" alt="" />
						<img class="m-auto mb-6 box-shadow" src="/img/elementum-db-min.png" srcset="/img/elementum-db@2x-min.png 2x" alt="" />
					</div>
				</div>
			</div>
		</div>

		<div class="mb-6 website-link-m sm:hidden"><a class="text-link" href="https://www.elliemae.com" target="_blank">Ellie Mae</a></div>
		<img class="m-auto sm:hidden box-shadow" src="/img/elliemae-m-min.png" srcset="/img/elliemae-m@2x-min.png 2x" alt="" />

		<FooterNav prev="/work/ellie-mae-blocks" next="/work/corporate-identity"></FooterNav>
	</WorkIt>
</template>

<script>
import Intro from '@/components/Intro.vue';
import WorkIt from '@/components/WorkIt.vue';
import FooterNav from '@/components/FooterNav.vue';

import { mapMutations } from 'vuex';

export default {
	components: {
		Intro,
		WorkIt,
		FooterNav
	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-work work-detail websites');
	}
}
</script>